import React, { useState } from "react"
import { useDispatch } from "react-redux"

import { handleZipDownload } from "@/utils/helper"
import { showToast } from "@/store/features/genericSlice"

import Button from "@/components/core/Button/Button"
import Checkbox from "@/components/core/Checkbox/Checkbox"

import twoDPlanDark from "@/public/icons/2D-plan.svg"
import twoDFrontDark from "@/public/icons/2D-front.svg"
import twoDSideDark from "@/public/icons/2D-side.svg"
import threeDIconDark from "@/public/icons/3D.svg"
import threeDBIMDark from "@/public/icons/3D-BIM.svg"
import cutoutIconDark from "@/public/icons/cutout.svg"
import { addDownloadFilesAnalytics } from "@/components/ProductDetail/v3/ProductAccordionList/analytics"

const DesignFiles = props => {
  const { files = {}, staticTexts = {}, sku = "", productInfo = "" } = props
  const [selectedFiles, setSelectedFiles] = useState([])
  const [loading, setLoading] = useState(false)
  const dispatch = useDispatch()

  const handleSelect = (checked, clickedItem, title) => {
    clickedItem.title = title
    if (checked) setSelectedFiles([...selectedFiles, clickedItem])
    else
      setSelectedFiles(
        selectedFiles.filter(item => item.url !== clickedItem.url)
      )
  }

  const handleSelectAll = checked => {
    if (checked) {
      const selected = []
      files.twoDimension.plan.forEach(obj => {
        const newObj = obj
        newObj.title = "2D Plan"
        selected.push(newObj)
      })
      files.twoDimension.front.forEach(obj => {
        const newObj = obj
        newObj.title = "2D Front"
        selected.push(newObj)
      })
      files.twoDimension.side.forEach(obj => {
        const newObj = obj
        newObj.title = "2D Side"
        selected.push(newObj)
      })
      files.threeDimension.forEach(obj => {
        const newObj = obj
        newObj.title = "3D File"
        selected.push(newObj)
      })
      files.bim.forEach(obj => {
        const newObj = obj
        newObj.title = "Bim"
        selected.push(newObj)
      })
      files.cutout.forEach(obj => {
        const newObj = obj
        newObj.title = "Cutout"
        selected.push(newObj)
      })
      setSelectedFiles(selected)
    } else setSelectedFiles([])
  }

  const handleDownloadError = () => {
    setLoading(false)
    dispatch(showToast("Download failed"))
    addDownloadFilesAnalytics(productInfo, selectedFiles, true)
  }

  const handleDownload = () => {
    const urlList = selectedFiles.map(item => item.url)
    if (selectedFiles.length > 1) {
      setLoading(true)
      handleZipDownload(
        urlList,
        sku,
        () => {
          setLoading(false)
          addDownloadFilesAnalytics(productInfo, selectedFiles)
        },
        handleDownloadError
      )
    } else if (urlList[0]) {
      window.open(urlList[0], "_blank")
      addDownloadFilesAnalytics(productInfo, selectedFiles)
    }
  }

  const designFilesLength =
    files.twoDimension.plan.length +
    files.twoDimension.front.length +
    files.twoDimension.side.length +
    files.threeDimension.length +
    files.bim.length +
    files.cutout.length

  return (
    <div className="pdp-technical-tile__download-section">
      <section className="pdp-technical-tile__select-all">
        <div id="selectAllfiles" tabIndex={-1}>
          <Checkbox
            inline
            textClassName="checkbox_default_text"
            tabIndex={0}
            value={staticTexts.selectAll}
            checked={
              designFilesLength > 0 &&
              selectedFiles.length === designFilesLength
            }
            onChange={e => handleSelectAll(e.target.checked)}
            disabled={!designFilesLength}
          />
        </div>
      </section>
      <div className="pdp-technical-tile__button-container">
        <Button
          role="button"
          loading={loading}
          customClass="pdp-technical-tile__download-btn"
          size="small"
          onClick={() => handleDownload()}
          flexible={true}
          label={`${staticTexts.download} ${
            selectedFiles.length > 0
              ? selectedFiles.length +
                " " +
                (selectedFiles.length === 1
                  ? staticTexts.file
                  : staticTexts.files)
              : ""
          }`}
          disabled={selectedFiles.length === 0}
          useDefaultClass={true}
        />
      </div>
      <div className="pdp-technical-tile__files">
        {files.twoDimension.plan.length > 0 && (
          <section>
            <span className="pdp-technical-tile__file-type">
              <img
                className="pt-0"
                alt=""
                aria-hidden="true"
                src={twoDPlanDark?.src}
              />
              <span className="pdp-technical-tile__file-type__title">
                {staticTexts.twoDplan}
              </span>
            </span>
            <div className="input-group">
              {files.twoDimension.plan.map((item, i) => (
                <Checkbox
                  inline
                  textClassName="checkbox_default_text"
                  key={i}
                  value={item.type}
                  checkBoxAria={`${staticTexts.twoDplan}  ${item.type}`}
                  checked={
                    selectedFiles.find(obj => obj.url === item.url)
                      ? true
                      : false
                  }
                  onChange={e =>
                    handleSelect(e.target.checked, item, "2D Plan")
                  }
                />
              ))}
            </div>
          </section>
        )}
        {files.twoDimension.front.length > 0 && (
          <section>
            <span className="pdp-technical-tile__file-type">
              <img
                className="pt-0"
                alt=""
                aria-hidden="true"
                src={twoDFrontDark?.src}
              />
              <span className="pdp-technical-tile__file-type__title">
                {staticTexts.twoDfront}
              </span>
            </span>
            <div className="input-group">
              {files.twoDimension.front.map((item, i) => (
                <Checkbox
                  inline
                  textClassName="checkbox_default_text"
                  key={i}
                  value={item.type}
                  checkBoxAria={`${staticTexts.twoDfront} ${item.type}`}
                  checked={
                    selectedFiles.find(obj => obj.url === item.url)
                      ? true
                      : false
                  }
                  onChange={e =>
                    handleSelect(e.target.checked, item, "2D Front")
                  }
                />
              ))}
            </div>
          </section>
        )}
        {files.twoDimension.side.length > 0 && (
          <section>
            <span className="pdp-technical-tile__file-type">
              <img
                className="pt-0"
                alt=""
                aria-hidden="true"
                src={twoDSideDark?.src}
              />
              <span className="pdp-technical-tile__file-type__title">
                {staticTexts.twoDside}
              </span>
            </span>
            <div className="input-group">
              {files.twoDimension.side.map((item, i) => (
                <Checkbox
                  inline
                  textClassName="checkbox_default_text"
                  key={i}
                  value={item.type}
                  checkBoxAria={`${staticTexts.twoDside} ${item.type}`}
                  checked={
                    selectedFiles.find(obj => obj.url === item.url)
                      ? true
                      : false
                  }
                  onChange={e =>
                    handleSelect(e.target.checked, item, "2D Side")
                  }
                />
              ))}
            </div>
          </section>
        )}
        {files.threeDimension.length > 0 && (
          <section>
            <span className="pdp-technical-tile__file-type">
              <img
                className="pt-0"
                alt=""
                aria-hidden="true"
                src={threeDIconDark?.src}
              />
              <span className="pdp-technical-tile__file-type__title">
                {staticTexts.threeDfile}
              </span>
            </span>
            <div className="input-group">
              {files.threeDimension.map((item, i) => (
                <Checkbox
                  inline
                  textClassName="checkbox_default_text"
                  key={i}
                  value={item.type}
                  checkBoxAria={`${staticTexts.threeDfile} ${item.type}`}
                  checked={
                    selectedFiles.find(obj => obj.url === item.url)
                      ? true
                      : false
                  }
                  onChange={e =>
                    handleSelect(e.target.checked, item, "3D File")
                  }
                />
              ))}
            </div>
          </section>
        )}
        {files.bim.length > 0 && (
          <section>
            <span className="pdp-technical-tile__file-type">
              <img
                className="pt-0"
                alt=""
                aria-hidden="true"
                src={threeDBIMDark?.src}
              />
              <span className="pdp-technical-tile__file-type__title">
                {staticTexts.bimFile}
              </span>
            </span>
            {files.bim.map((item, i) => (
              <Checkbox
                inline
                textClassName="checkbox_default_text"
                key={i}
                value={item.type}
                checkBoxAria={`${staticTexts.bimFile} ${item.type}`}
                checked={
                  selectedFiles.find(obj => obj.url === item.url) ? true : false
                }
                onChange={e => handleSelect(e.target.checked, item, "Bim")}
              />
            ))}
          </section>
        )}
        {files.cutout.length > 0 && (
          <section>
            <span className="pdp-technical-tile__file-type">
              <img
                className="pt-0"
                alt=""
                aria-hidden="true"
                src={cutoutIconDark?.src}
              />
              <span className="pdp-technical-tile__file-type__title">
                {staticTexts.cutoutTemplate}
              </span>
            </span>
            {files.cutout.map((item, i) => (
              <Checkbox
                inline
                textClassName="checkbox_default_text"
                key={i}
                checkBoxAria={`${staticTexts.cutoutTemplate} ${item.type}`}
                value={item.type}
                checked={
                  selectedFiles.find(obj => obj.url === item.url) ? true : false
                }
                onChange={e => handleSelect(e.target.checked, item, "Cutout")}
              />
            ))}
          </section>
        )}
      </div>
    </div>
  )
}

export default DesignFiles
